export type NotificationVariant = 'mobile' | 'desktop'

export const notificationText = {
  primary: 'text-[rgba(255,255,255,0.87)]',
  secondary: 'text-[rgba(255,255,255,0.6)]',
  disabled: 'text-[rgba(255,255,255,0.38)]',
  inactive: 'text-[rgba(255,255,255,0.5)]',
  pure: 'text-white',
} as const

/** Mobile Figma: fill + radius only. Desktop popover keeps stroke. */
export function notificationSurfaceCard(variant: NotificationVariant) {
  if (variant === 'desktop') {
    return 'rounded-[12px] border border-[rgba(79,82,112,0.75)] bg-[rgba(255,255,255,0.05)]'
  }
  return 'rounded-[calc(12*var(--vw))] bg-[rgba(255,255,255,0.05)]'
}

export const notificationUnread = 'bg-[#FD5251]'
export const notificationPlaceholder = 'bg-[#D9D9D9]'
